import I18nForLwText from './LwText'

export default class I18nForLwDate extends I18nForLwText {
  name = 'lw-date'
}
